import * as React from 'react';
import ThumbnailFile from './thumbnail/ThumbnailFile';
import {downloadFileFromURL, getFileMimeTypeFromURL} from '../../../../common/utils/GeneralUtils';
import {GROUP} from '../../../group/constants/LabelConstants';
import {LOAN_APPLICATION_MX} from '../../../constants/LabelConstants';
import {BankAccountDetailsDispatchProps, BankAccountDetailsProps} from '../../../group/types/mx/containers';
import {FILES_SECTION} from '../../../loan/common/constants/LabelConstants';

class BankAccountDetailView extends React.Component<BankAccountDetailsProps
    & BankAccountDetailsDispatchProps, {}> {

    onCancel = () => this.props.onCancel();

    onDownload = (item) => {
        const type: string = !!item.mimeType ? item.mimeType : getFileMimeTypeFromURL(item.url);
        return downloadFileFromURL(item.url, item.name, type);
    }

    onSelect = (file) => {
        window.open(file.url, '_blank');
    }

    render() {
        const {
            accountNumber,
            beneficiaryName,
            bank,
            clabe,
            ownerName,
            createdAt,
            dealerAccountStatusFile,
            dealerOfficialIdentificationFile,
            isUserGroupAdmin
        } = this.props;
        const btnStyle = 'btn btn-link btn-form border-0 h-100 pb-2';

        return (
            <div id="detailView" className="col-12 px-0 pt-5 pb-0">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_ACCOUNT_NUMBER_FIELD_TITLE}</div>
                                        <div className="detail-information">
                                            {accountNumber}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_BENEFICIARY_NAME_TITLE}</div>
                                        <div className="detail-information">
                                            {beneficiaryName}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_BANK_TITLE}</div>
                                        <div className="detail-information">{bank}</div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_CLABE_INTERBANK_TITLE}</div>
                                        <div className="detail-information">{clabe}</div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_BANK_ACCOUNT_ADD_BY}</div>
                                        <div className="detail-information">
                                            {`${ownerName} ${createdAt.displayValue}`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_DEALER_ACCOUNT_STATUS_LABEL}</div>
                                        <div className="detail-information w-100">
                                            <ThumbnailFile
                                                defaultClass="clickable-component"
                                                showPDFBackground={true}
                                                onClick={() => this.onSelect(dealerAccountStatusFile)}
                                                file={dealerAccountStatusFile}/>
                                        </div>
                                        {isUserGroupAdmin && <div className="link-details mt-2" onClick={() =>
                                            this.onDownload(dealerAccountStatusFile
                                            )}>
                                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                                        </div>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="title-label">
                                            {GROUP.GROUP_DEALER_OFFICIAL_IDENTIFICATION_LABEL}
                                        </div>
                                        <div className="detail-information w-100">
                                            <ThumbnailFile
                                                defaultClass="clickable-component"
                                                showPDFBackground={true}
                                                onClick={() => this.onSelect(dealerOfficialIdentificationFile)}
                                                file={dealerOfficialIdentificationFile}/>
                                        </div>
                                        {isUserGroupAdmin && <div id="downloadOpt" className="link-details mt-2"
                                             onClick={() =>
                                                 this.onDownload(
                                                     dealerOfficialIdentificationFile
                                                 )}>
                                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 pt-3 px-0 border-top mt-4">
                    <div className="d-flex justify-content-end">
                        <a className={`${btnStyle} text-secondary-lighten-5`}
                           onClick={this.onCancel}>{FILES_SECTION.CANCEL_LABEL}</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default BankAccountDetailView;
